module.exports = __webpack_public_path__ + "img/about-enterprise3.64969cac.png";